import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  packagesAndPrices: 'Packages and Prices',
  selectPlanDescription: 'Select the plan that best fits your needs',
  individuals: 'Individuals',
  companies: 'Companies',
  faqsTitle: 'FAQs',
  availableAreas: 'Available areas',
  tiersTitle: 'Areas',
  tiersDescription: 'This package covers the following Locations',
  areas: 'Areas',
  noAreasFound: 'No available areas found.',
  month: 'Month',
  months: 'Months',
  subscribeNow: 'Subscribe Now',
  pointsValue: '{{value}} Points',
  pointsIncludedValue: 'Includes <tag>{{value}}</tag> points',
  toAddListings: 'To add listings',
  payAsYouGoTitle: 'Pay as you go',
  payAsYouGoDescription:
    'Buy credits when you need them and use them at your own pace.',
  customizePackageTitle: 'Customize your package',
  customizePackageDescription:
    'Need a tailored offer for your business? We can build the right package for you.',
  contactUs: 'Contact us',
  addonsPackagesTitle: 'Add-ons',
  addonsPackageDescription:
    'Enjoy additional benefits to get the most out of your subscription.',
  addToMyPackage: 'Add to my package',
  egpPerMonth: 'EGP/month',
  noIndividualPackagesFound: 'No Individual Packages Found.',
  noCompaniesPackagesFound: 'No Companies Packages Found.',
  customizePackageFooter:
    'Our team will contact you within one business day of your submission.',
  rentOnly: 'Rent Only',
  pointsTooltip:
    'Points can be redeemed for listing new properties or featuring your listings',
  activationFees: 'Activation Fees <tag>(First Time Only)</tag>',
  packageSubscriptionExpiry: 'Subscription expires after {{days}} days',
  packageCreditExpiry: 'Credits expire after {{days}} days',
  allAreas: 'All',
  moreServices: 'More Services',
  lessServices: 'Less Services',
  packagePaymentSummary: 'Payment Summary',
  packagePaymentInfo: 'Payment Information',
});
